// extracted by mini-css-extract-plugin
export default {"heading":"Fv-z","corrected":"Gv-z","redirectVerbiageContainer":"Hv-z","redirectVerbiageText":"Iv-z"};